module.exports = __webpack_public_path__ + "static/media/plane(1).cab34b78.PNG";